import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PublicIcon from '@mui/icons-material/Public';
import AddModeratorOutlinedIcon from '@mui/icons-material/AddModeratorOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Chip from '@mui/material/Chip';
import { AccessEnum } from '@shared/types';
import OverflowTooltip from '@shared/components/ui/OverflowTooltip';

interface AccessChipProps {
    access: AccessEnum;
}

const AccessChip: FC<AccessChipProps> = ({ access }) => {
    const { t } = useTranslation();

    const Icon = useMemo(() => {
        const MAP_ACCESS_TO_ICON = {
            Public: PublicIcon,
            Locked: LockOutlinedIcon,
            Private: AddModeratorOutlinedIcon,
        };

        return MAP_ACCESS_TO_ICON[access];
    }, [access]);

    if (!access) {
        return null;
    }

    return (
        <Chip
            icon={<Icon sx={{ width: 16, height: 16 }} color="primary" />}
            sx={{
                padding: '3px 4px',
                fontSize: '0.813rem',
                background: 'var(--components-chip-tinted)',
                '& .MuiChip-label': {
                    padding: '0 6px',
                    lineHeight: '18px',
                },
                '&.MuiChip-root': {
                    gap: '4px !important',
                },
            }}
            size="small"
            label={<OverflowTooltip title={t(access.toLowerCase())}>{t(access.toLocaleLowerCase())}</OverflowTooltip>}
        />
    );
};

export default AccessChip;
